import { render, staticRenderFns } from "./editpass_modal.vue?vue&type=template&id=46b75300&scoped=true&"
import script from "./editpass_modal.vue?vue&type=script&lang=js&"
export * from "./editpass_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b75300",
  null
  
)

export default component.exports